import React from "react";
import CmsPage from "../CmsPage/CmsPage";
import "./OurTeam.scss";

const OurTeam = (props) => {
  return <CmsPage id={1} />;
};

export default OurTeam;
